import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-upload-word-template',
    templateUrl: './upload-word-template.component.html',
    styleUrls: ['./upload-word-template.component.scss'],
    standalone: false
})
 //@author kameshwar.d @date 09-09-2025

export class UploadWordTemplateComponent implements OnInit {

  FormWordTemplate: FormGroup;

  // Word file
  statevaluechange = { wordFileName: '' };
  selectedFile: File | null = null;
  fileUploaded = false;

  // Excel file
  excelFileName = '';
  selectedExcelFile: File | null = null;
  excelFileUploaded = false;

  backgroundColorScreen = '';
  buttonColor = '';
  titleText = 'Upload & Regenerate Product Strategy Template';

  rowData: any;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UploadWordTemplateComponent>,
    private snackBar: MatSnackBar,
    private localStorageSettings: LocalStorageSettingsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private jsignalsService: JsignalService,
    private spinner: NgxUiLoaderService
  ) {
    this.FormWordTemplate = this.fb.group({
      wordTemplateName: [''],
      wordTemplateUpload: [''],
      excelTemplateUpload: ['']
    });

    this.rowData = data?.data;
    console.log('Received data in dialog:', this.rowData);
  }

  ngOnInit(): void {
    this.backgroundColorScreen = this.localStorageSettings.getSettings('ColorD');
    this.buttonColor = this.localStorageSettings.getSettings('ColorA');
  }

  // Word file selection
  wordFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file: File | undefined = input.files?.[0];
    if (!file) return;

    const allowedExtensions = ['docx'];
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
      this.snackBar.open('Only .docx files are allowed!', 'Close', { duration: 3000 });
      input.value = '';
      return;
    }

    this.selectedFile = file;
    this.statevaluechange.wordFileName = file.name;
    this.FormWordTemplate.get('wordTemplateUpload')?.setValue(file);
    this.fileUploaded = true;
  }

  // Excel file selection
  excelFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file: File | undefined = input.files?.[0];
    if (!file) return;

    const allowedExtensions = ['xlsx'];
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
      this.snackBar.open('Only .xlsx files are allowed!', 'Close', { duration: 3000 });
      input.value = '';
      return;
    }

    this.selectedExcelFile = file;

    console.log(file.name)

    this.excelFileName = file.name;
    this.FormWordTemplate.get('excelTemplateUpload')?.setValue(file);
    this.excelFileUploaded = true;
  }

  //  upload for Word & Excel
  uploadTemplates(): void {
  if (!this.selectedFile || !this.selectedExcelFile) {
    this.snackBar.open('Both Word and Excel files are mandatory!', 'Close', { duration: 3000 });
    return;
  }
  this.spinner.start()

  const formData = new FormData();
  formData.append('wordFile', this.selectedFile, this.selectedFile.name);
  formData.append('excelFile', this.selectedExcelFile, this.selectedExcelFile.name);
  formData.append('templateId', this.rowData.templateId);

  this.jsignalsService.uploadTemplates(formData).subscribe({
    next: (res) => {
      this.spinner.stop()
      this.snackBar.open(res, 'Close', { duration: 3000 });
       this.closeTemplate();
    },
    error: (err) => {
            this.spinner.stop()

      this.snackBar.open('Upload failed: ' + err.error, 'Close', { duration: 3000 });
    }
  });
}


  regenerateWordTemplate(): void {
    if (this.fileUploaded) {
      console.log('Regenerating Word template...');
    }
  }

  closeTemplate(): void {
    this.resetForm();
    this.dialogRef.close();
  }

  private resetForm(): void {
    this.FormWordTemplate.reset();
    this.statevaluechange.wordFileName = '';
    this.excelFileName = '';
    this.selectedFile = null;
    this.selectedExcelFile = null;
    this.fileUploaded = false;
    this.excelFileUploaded = false;
  }
}
